import styled from '@emotion/styled'
import { Box, Button, Card, CardActions, CardContent, Grid, Stack, Typography } from '@mui/material'
import { motion } from 'framer-motion'
import React from 'react'
import useStyles from '../components/MainTitle'
import {AiOutlineGlobal} from "react-icons/ai"
import {GoDeviceMobile} from "react-icons/go"
import {TbDeviceDesktopAnalytics} from "react-icons/tb"
import {VscTerminalBash} from "react-icons/vsc"
import {MdOutlineDesignServices} from "react-icons/md"
import {TbBrandAsana} from "react-icons/tb"

const CardItem = styled(Card)(({theme}) => ({
  width: "100%",
  border: `1px solid ${theme.palette.grey.dark}`,
  paddingleft: "15px", 
  boxShadow: "none",
  transition: "all 0.3s ease",
  padding:"15px",
  "&:hover": {
    backgroundColor: theme.palette.primary.main,
    transform: "translateY(-10px)",
    "& > *": {
      color: "white"
    },
    "& > button": {
      backgroundColor: "white",
      color: theme.palette.primary.main,
    }
  }
}))
const ItemIcon = styled("div")(({theme})=> ({
  color: theme.palette.primary.main,
  margin: "10px 0",

}))
function Services() {
  const classes = useStyles()
  return (
    <>
      <Box sx={{paddingBottom: {xs: "120px", md: "100px"}, overflowX: "hidden"}}>
        <Stack direction="row">
          <Box className={classes.BigTitle}>
          <motion.div initial={{opacity: 0, y: 50}} animate={{opacity: 1, y: 0, transition: {duration: 1}}} >What I Do ?</motion.div>
            <Box className={classes.SmallTitle}>
              <motion.div initial={{opacity: 0, y: -50}} animate={{opacity: 1, y: 0, transition: {duration: 1}}}>
                SERVICES
                <Box className={classes.afterClass} />
              </motion.div>
            </Box>
          </Box>
        </Stack>
        <Grid spacing={2} container sx={{transform: {xs: "translateY(40px)", md: "translateY(70px)"} }}>
          <Grid item xs={12} md={6} lg={4} sx={{textAlign: "center"}}>
            <motion.div initial={{opacity: 0, y: -50}} animate={{opacity: 1, y: 0, transition: {duration: .5, delay: 1}}} >
              <CardItem>
                <ItemIcon>
                  <AiOutlineGlobal fontSize={40}/>
                </ItemIcon>
                <Typography component={"h2"} sx={{fontSize: "1.1rem", fontWeight: "600"}}>Web Development</Typography>
                <Typography component={"p"} sx={{fontSize: ".8rem", lineHeight: "1.6"}}>"Our web development services cover all aspects of the development process, from design and front-end development to back-end programming and database integration.
                </Typography>
                <Button variant='contained' sx={{fontSize: ".7rem", marginTop: "15px"}}>
                  Read More
                </Button>
              </CardItem>
            </motion.div>
          </Grid>
          <Grid item xs={12} md={6} lg={4} sx={{textAlign: "center"}}>
            <motion.div initial={{opacity: 0, y: -50}} animate={{opacity: 1, y: 0, transition: {duration: .5, delay: 1.2}}} >
              <CardItem>
                <ItemIcon>
                  <GoDeviceMobile fontSize={40}/>
                </ItemIcon>
                <Typography component={"h2"} sx={{fontSize: "1.1rem", fontWeight: "600"}}>Responsive Design</Typography>
                <Typography component={"p"} sx={{fontSize: ".8rem", lineHeight: "1.6"}}>We believe that responsive design is essential for any modern digital presence, and our services prioritize creating seamless user experiences across all screens and platforms
                </Typography>
                <Button variant='contained' sx={{fontSize: ".7rem", marginTop: "15px"}}>
                  Read More
                </Button>
              </CardItem>
            </motion.div>
          </Grid>
          <Grid item xs={12} md={6} lg={4} sx={{textAlign: "center"}}>
          <motion.div initial={{opacity: 0, y: -50}} animate={{opacity: 1, y: 0, transition: {duration: .5, delay: 1.4}}} >
              <CardItem>
                <ItemIcon>
                  <TbDeviceDesktopAnalytics fontSize={40}/>
                </ItemIcon>
                <Typography component={"h2"} sx={{fontSize: "1.1rem", fontWeight: "600"}}>Business Analysis</Typography>
                <Typography component={"p"} sx={{fontSize: ".8rem", lineHeight: "1.6"}}>Our business analysis services help organizations make data-driven decisions, optimize their operations, and identify new opportunities for growth and innovation.
                </Typography>
                <Button variant='contained' sx={{fontSize: ".7rem", marginTop: "15px"}}>
                  Read More
                </Button>
              </CardItem>
            </motion.div>
          </Grid>
          <Grid item xs={12} md={6} lg={4} sx={{textAlign: "center"}}>
          <motion.div initial={{opacity: 0, y: -50}} animate={{opacity: 1, y: 0, transition: {duration: .5, delay: 1.6}}} >
              <CardItem>
                <ItemIcon>
                  <VscTerminalBash fontSize={40}/>
                </ItemIcon>
                <Typography component={"h2"} sx={{fontSize: "1.1rem", fontWeight: "600"}}>SEO Marketing</Typography>
                <Typography component={"p"} sx={{fontSize: ".8rem", lineHeight: "1.6"}}>Our SEO marketing services help businesses improve their online visibility and attract more organic traffic to their website, with strategies that are tailored to their audience.
                </Typography>
                <Button variant='contained' sx={{fontSize: ".7rem", marginTop: "15px"}}>
                  Read More
                </Button>
              </CardItem>
            </motion.div>
          </Grid>
          <Grid item xs={12} md={6} lg={4} sx={{textAlign: "center"}}>
          <motion.div initial={{opacity: 0, y: -50}} animate={{opacity: 1, y: 0, transition: {duration: .5, delay: 1.8}}} >
              <CardItem>
                <ItemIcon>
                  <MdOutlineDesignServices fontSize={40}/>
                </ItemIcon>
                <Typography component={"h2"} sx={{fontSize: "1.1rem", fontWeight: "600"}}>E-commerce Design</Typography>
                <Typography component={"p"} sx={{fontSize: ".8rem", lineHeight: "1.6"}}>Our E-commerce design services help businesses of all sizes establish a robust online sales presence, with custom-built websites and applications that leverage the latest technologies.
                </Typography>
                <Button variant='contained' sx={{fontSize: ".7rem", marginTop: "15px"}}>
                  Read More
                </Button>
              </CardItem>
            </motion.div>
          </Grid>
          <Grid item xs={12} md={6} lg={4} sx={{textAlign: "center"}}>
            <motion.div initial={{opacity: 0, y: -50}} animate={{opacity: 1, y: 0, transition: {duration: .5, delay: 2}}} >
              <CardItem>
                <ItemIcon>
                  <TbBrandAsana fontSize={40}/>
                </ItemIcon>
                <Typography component={"h2"} sx={{fontSize: "1.1rem", fontWeight: "600"}}>Branding</Typography>
                <Typography component={"p"} sx={{fontSize: ".8rem", lineHeight: "1.6"}}>We specialize strategies that cover all aspects of a business's visual identity, from the creation of brand guidelines to the design of marketing collateral.
                </Typography>
                <Button variant='contained' sx={{fontSize: ".7rem", marginTop: "15px"}}>
                  Read More
                </Button>
              </CardItem>
            </motion.div>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default Services
